import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledImage = styled.img`
  width: 280px;
  height: auto;
  margin-bottom: 10px;

  @media (min-width: 600px) {
    width: 360px;
  }

  @media (min-width: 1000px) {
    width: 400px;
  }

  &.logo-marista {
    grid-area: logo-marista;
  }
`;

export const Container = styled.div`
  min-height: 85dvh;
  @media (min-width: 600px) {
    min-height: 80dvh;
  }
  max-width: 1000px;
  margin: 0 auto;
`;

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 60px 24px;

  @media (min-width: 600px) {
    padding: 120px 0;
  }

  h1 {
    color: #46b2ff;
    font-family: Museo;
    font-size: 2.5rem;

    @media (min-width: 600px) {
      font-size: 3.75rem;
    }

    @media (min-width: 1000px) {
      font-size: 5rem;
    }

    font-weight: 900;
    text-transform: uppercase;
    margin-bottom: 24px;

    & span:first-child {
      color: #ffffff;
    }

    & span:last-child {
      color: #FFBA13;
    }
  }

  h3 {
    color: #132bae;
    font-size: 16px;
    font-family: Museo;
    font-weight: 700;
    text-align: center;
  }
`;

export const Hero = styled.div`
  padding-bottom: 24px;
  border-bottom: 1px solid #fff;

  @media (min-width: 1000px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 120px;
    grid-template-areas: "title logoMarista"
  }
`;

export const TitleContainer = styled.div`
  grid-area: title;
`;

export const StyledButton = styled.div`
  width: 120px;
  height: 90%;
  background: #ffba13;
  box-shadow: 0px 4px 0px #d66222;
  border-radius: 50px;
  justify-content: center;
  align-items: center;
  gap: 22.02px;
  display: flex;
  cursor: pointer;
  margin: 0 auto;
  padding: 12px 24px;

  &:hover {
    background: #ffd34a;
  }

  @media (min-width: 600px) {
    padding: 16px 32px;
    width: 140px;
    justify-self: end;
  }
`;

export const CreditsButton = styled.div`
  width: 120px;
  height: 90%;
  background: transparent;
  border: 1px solid #fff;
  border-radius: 50px;
  justify-content: center;
  align-items: center;
  gap: 22.02px;
  display: flex;
  cursor: pointer;
  margin: 0 auto;
  padding: 12px 24px;

  &:hover {
    background: #8a4ad0;
  }

  @media (min-width: 600px) {
    padding: 16px 32px;
    width: 140px;
    justify-self: end;
  }
`;

export const LinkStyled = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

export const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-template-areas: 
    ". . begin"
    ". . credits";
  gap: 16px;

  a {
    font-family: Museo;
    font-weight: 700;
    font-size: 1rem;
    color: #fff;
    text-align: center;
    text-decoration: none;
  }

  a:first-child {
    grid-area: begin;
    justify-self: end;
  }

  a:last-child {
    grid-area: credits;
    justify-self: end;
  }
`;
